export default __webpack_public_path__ + "static/media/formarrow.e801187e.svg";